import qs from 'qs';
import { push } from 'react-router-redux';

import { getStore, getState } from '../../store';
import { ACTIONS } from './actions';
import * as AnalyticsService from '../../../api/service/AnalyticsService';
import * as AppState from '../app/appState';

export const loadMeta = async () => {
    const response = await AnalyticsService.getMeta();
    const metaTree = {
        categories: {},
        instances: {}
    };
    for (let category of response.categories) {
        metaTree.categories[category.key] = category;
    }
    for (let instance of response.instances) {
        metaTree.instances[instance.key] = instance;
    }
    getStore().dispatch({
        type: ACTIONS.INITIALIZE_META,
        metaTree
    });
};

export const getInstanceMeta = async key => {
    let meta = getState().analytics.metaTree.instances[key];
    if (!meta) {
        await loadMeta();
        meta = getState().analytics.metaTree.instances[key];
        if (!meta) {
            alert('Analytics Error!: Undefined Key');
            return false;
        }
    }
    return meta;
};

export const updateSearchParams = searchParams => {
    searchParams = qs.stringify(searchParams);
    clearAnalyticsData();
    AppState.setAnalyticsLoading();
    getStore().dispatch(push({ search: searchParams }));
};

export const getSearchParams = () => {
    let [questionMark, ...queryString] = location.search;
    let search = qs.parse(queryString.join(''));
    return search;
};

export const navigate = path => {
    clearAnalyticsData();
    AppState.setAnalyticsLoading();
    AppState.navigate(path);
};

export const clearAnalyticsData = () => {
    getStore().dispatch({
        type: ACTIONS.INITIALIZE,
        title: '',
        columns: [],
        rows: [],
        defaultSort: null,
        graphData: null,
        summary: null
    });
};
